/* @ngInject */
const dispatchIcons = () => {
  const self = {}

  self.date = 'today'
  self.hour = 'alarm'
  self.prg = 'train'
  self.sgm = 'train'
  self.comment = 'mode_edit'
  self.departure = 'train'
  self.start = 'train'
  self.delivery = 'train'
  self.tractionnaire = 'train'

  return self
}

export default dispatchIcons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/dispatch/resources/icons.resource.js